var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI06Headphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82555 23.1125V19.4625C6.82555 18.25 7.77555 17.1625 9.12555 17.1625C10.338 17.1625 11.4255 18.1125 11.4255 19.4625V22.975C11.4255 25.4125 9.40055 27.4375 6.96305 27.4375C4.52555 27.4375 2.50055 25.4 2.50055 22.975V15.275C2.36305 8.25 7.91305 2.5625 14.938 2.5625C21.963 2.5625 27.5005 8.25 27.5005 15.1375V22.8375C27.5005 25.275 25.4755 27.3 23.038 27.3C20.6005 27.3 18.5755 25.275 18.5755 22.8375V19.325C18.5755 18.1125 19.5255 17.025 20.8755 17.025C22.088 17.025 23.1755 17.975 23.1755 19.325V23.1125",
    stroke: "white",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI06Headphone);
export default __webpack_public_path__ + "static/media/I06-headphone.b4a952bb92b29a948929035546a0d690.svg";
export { ForwardRef as ReactComponent };